import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ContextService } from '../../services/context/context.service';
import { DataService } from '../../services/context/data.service';
import { UIStateService } from '../../services/context/uistate.service';
import { AppMonitoringService } from '../../services/util/app-monitoring.service';
import * as fromModel from '../../services/models';
import { RefDataService } from '../../services/context/ref-data.service';
import { Utils } from '../../../utils/utils';
import { MatDialog } from '@angular/material/dialog';
import { EditIncomeComponent } from '../edit-income/edit-income.component';
import { DeleteConfirmationComponent } from '../../context-components/delete-confirmation/delete-confirmation.component';
import { MatMenuTrigger } from '@angular/material/menu';

@Component({
  selector: 'gp-income-summary',
  templateUrl: './income-summary.component.html',
  styleUrls: ['./income-summary.component.scss']
})
export class IncomeSummaryComponent implements OnInit, OnChanges, OnDestroy {

  @Output() UpdateIncome: EventEmitter<any> = new EventEmitter();
  @Input("Refresh") refresh: string;
  @ViewChild('addIncomeMenuTrigger') addIncomeMenuTrigger: MatMenuTrigger;
  
  protected _storeDataSubscription: Subscription;
  
  Incomes: fromModel.Income[]; 
  incomes = [];       
  incomeTypesRef: fromModel.CodeValue[];
  incomeTypeMenuItems = [];
  primaryClient: fromModel.PlanClient;
  secondaryClient: fromModel.PlanClient;
  isDataChanged = false;

  constructor(
    private contextService:ContextService,
    private refDataService: RefDataService,
    private dataService:DataService,
    private uiStateService: UIStateService,
    private dialog: MatDialog, 
    private appMonitoringService: AppMonitoringService) {      
  }

  ngOnInit(): void {
    this._storeDataSubscription = this.dataService.subscribe((appData: fromModel.IAppData) => this.populateAppData(appData));           
    this.prepareIncomeMenu();    
  }

  ngOnChanges(changes: SimpleChanges) { 
    this.incomes = [];
    this.isDataChanged = false;
    this.populatIncomes();  
  }


  private populateAppData(appData: fromModel.IAppData){
    this.Incomes = [];
    if(appData && appData.action!==fromModel.DATA_ACTION.NONE){
      //this.incomes = [];
      this.populatIncomes();
    }
  }

  populatIncomes(){    
    let incTypeDesc;
    let ownerName;
    let start;
    let end;
    let amount;
    let incId;
    let isIncluded;
    let incDesc;
    let isMonthly;

    this.Incomes = this.dataService.getAllIncomes();    
      this.Incomes.forEach(inc => {
        incId = inc.incId;
        incDesc = inc.incDesc;
        isIncluded = inc.isIncluded;
        isMonthly = inc.isMonthly;

        incTypeDesc = this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.Incomes, inc.incType).value;        
        if(inc.owner){
          ownerName = this.dataService.getPlanClientByClientId(inc.owner).clientname;
        } else {
          ownerName = "Joint";
        }        

        if(inc.amtPeriod[0].startType === fromModel.AMOUNTPERIODTYPE.Year){
          start = inc.amtPeriod[0].startYr;
        } else if(inc.amtPeriod[0].startType === fromModel.AMOUNTPERIODTYPE.Age){
          start = Utils.getYearByAge(this.dataService.getPlanClientByClientId(inc.owner).age, inc.amtPeriod[0].startAge);
        } else if(inc.amtPeriod[0].startType === fromModel.AMOUNTPERIODTYPE.AtRet){
          start = this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.StartType, inc.amtPeriod[0].startType).value;
        } else if(inc.amtPeriod[0].startType === fromModel.AMOUNTPERIODTYPE.AtEnd){
          start = this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.StartType, inc.amtPeriod[0].startType).value;
        }

        if(inc.amtPeriod[0].endType === fromModel.AMOUNTPERIODTYPE.Year){
          end = inc.amtPeriod[0].endYr;
        } else if(inc.amtPeriod[0].endType === fromModel.AMOUNTPERIODTYPE.Age){
          end = Utils.getYearByAge(this.dataService.getPlanClientByClientId(inc.owner).age, inc.amtPeriod[0].endAge);
        } else if(inc.amtPeriod[0].endType === fromModel.AMOUNTPERIODTYPE.AtRet){
          end = this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.StartType, inc.amtPeriod[0].endType).value;
        } else if(inc.amtPeriod[0].endType === fromModel.AMOUNTPERIODTYPE.AtEnd){
          end = this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.StartType, inc.amtPeriod[0].endType).value;
        } else if(inc.amtPeriod[0].endType === fromModel.AMOUNTPERIODTYPE.Duration){
          end = `for ${inc.amtPeriod[0].duration} years`; 
        }
        amount = inc.amtPeriod[0].amount;
        // inc.growthTypeDesc = this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.GrowthRates, inc.growthType).value;

        // Updating income in this.income object if Income is updated
        const tempInc = this.incomes.find(_inc=>_inc.incId === incId);
        if(tempInc){
          tempInc.incDesc = incDesc;
          tempInc.incTypeDesc = incTypeDesc;
          tempInc.ownerName = ownerName;
          tempInc.isMonthly = isMonthly;
          tempInc.start = start;
          tempInc.end = end;
          tempInc.amount = amount;
        } else {
            this.incomes.push({incId: incId, incDesc: incDesc, incTypeDesc: incTypeDesc, 
            ownerName: ownerName, isMonthly: isMonthly, start: start, end:end, amount: amount, isIncluded: isIncluded });
        }
      });

      // Removing income from this.income object if Income is  deleted
      let incPos;
      this.incomes.forEach(inc => {
        const _inc = this.Incomes.find(income=>income.incId === inc.incId);
        if(!_inc){
          incPos = this.incomes.indexOf(inc);
        }
      });
      if(incPos>-1){
        this.incomes.splice(incPos, 1); 
      }      
  }

  prepareIncomeMenu(){

    let subMenuItems = [];
    this.incomeTypesRef = this.refDataService.getPlanningUIRefDataByType(fromModel.PLANNINGUIREFTYPE.Incomes);
    this.primaryClient = this.dataService.getClientByRole(fromModel.CLIENTROLE.Primary);
    this.incomeTypesRef.forEach(incTypeRef => {
      let incomeTypeMenuItem = {
        code: incTypeRef.code,
        value: incTypeRef.value,
        clientid: this.primaryClient.clientid,
        clientname: this.primaryClient.clientname        
      };  
      subMenuItems.push(incomeTypeMenuItem);
    });

    this.incomeTypeMenuItems.push({displayClientname: `Income for ${this.primaryClient.clientname}`, type:'Primary', subMenuItems: subMenuItems});

    this.secondaryClient = this.dataService.getClientByRole(fromModel.CLIENTROLE.Secondary);
    if(this.secondaryClient){
      subMenuItems = [];
      this.incomeTypesRef.forEach(incTypeRef => {
        let incomeTypeMenuItem = {
          code: incTypeRef.code,
          value: incTypeRef.value,          
          clientid: this.secondaryClient.clientid,
          clientname: this.secondaryClient.clientname          
        };  
        subMenuItems.push(incomeTypeMenuItem);
      });
      this.incomeTypeMenuItems.push({displayClientname: `Income for ${this.secondaryClient.clientname}`, type:'Secondary', subMenuItems: subMenuItems});
    }

    
    if(this.secondaryClient){
      subMenuItems = [];
      let incomeTypesRefForJoint = this.incomeTypesRef.filter(({code})=> code === fromModel.INCOMETYPE.OT);
      incomeTypesRefForJoint.forEach(incTypeRef => {
        let incomeTypeMenuItem = {
          code: incTypeRef.code,
          value: incTypeRef.value,          
          clientid: '',
          clientname: "Joint"       
        };  
        subMenuItems.push(incomeTypeMenuItem);
      });
      this.incomeTypeMenuItems.push({displayClientname: 'Joint Income', type:'Joint', subMenuItems: subMenuItems});
    }    

      //console.log("incomeTypeMenuItems" + JSON.stringify(this.incomeTypeMenuItems));
  }

  addIncome(incType, clientid){
    //this.addIncomeMenuTrigger.closeMenu();
    this.openModelDialog(fromModel.OPENDIALOGACTIONS.ADDINCOME, incType, clientid);
  }


  editIncome(incomeId){  
    this.openModelDialog(fromModel.OPENDIALOGACTIONS.EDITINCOME, incomeId)
  }

  deleteIncome(incomeId, incomeDesc){
    this.openModelDialog(fromModel.OPENDIALOGACTIONS.DELETEINCOME,incomeId,incomeDesc);    
  }


  selectIncome(incomeId){  
    let income = this.incomes.find(inc=> inc.incId === incomeId);
    if(income){
      income.isIncluded = !income.isIncluded;
      this.isDataChanged = true;
    }
  }

  saveSelectedIncomes() {    
    let selectedIncomes = [];

    this.incomes.forEach(inc => {
      if(inc.isIncluded){
        selectedIncomes.push(inc.incId)
      }
    });    
    this.dataService.dispatchAction(fromModel.DATA_ACTION.SELECTEDINCOME, "IncomeSummaryComponent-saveSelectedIncomes", selectedIncomes);
    this.dataService.savePlan();
  }

  openModelDialog(action: fromModel.OPENDIALOGACTIONS, parm1?: string, parm2?: string){
    switch(action){
      case fromModel.OPENDIALOGACTIONS.ADDINCOME: {
        const dialogRef = this.dialog.open(EditIncomeComponent, {
          width: '70%',
          height: '70%',
          data: {incType: parm1, clientid: parm2},
          //data: expense,
          disableClose: true    
          }).afterClosed()
          .subscribe(result => {
            if(result && result.isSaved && result.expense && result.expense.isIncluded){
              //this.refreshExpense(result.expense);              
              this.UpdateIncome.emit();
            }
          });        
        break;
      }
      case fromModel.OPENDIALOGACTIONS.EDITINCOME: {
        const dialogRef = this.dialog.open(EditIncomeComponent, {
          width: '70%',
          height: '70%',
          data: {incomeId: parm1},
          //data: expense,
          disableClose: true    
          }).afterClosed()
          .subscribe(result => {
            if(result && result.isSaved && result.expense && result.expense.isIncluded){
              //this.refreshExpense(result.expense);              
              this.UpdateIncome.emit();
            }
          });        
        break;
      }          
      case fromModel.OPENDIALOGACTIONS.DELETEINCOME: {
        const dialogRef = this.dialog.open(DeleteConfirmationComponent, {
          width: '500px',
          height: '240px',
          data: { deleteType: fromModel.DELETETYPE.Income, name: parm2}                  
        }).afterClosed()
        .subscribe(isDeleted => {
          if(isDeleted){
            let inc = this.dataService.getIncomeByIncomeId(parm1);
            //let goal = this.dataService.getGoalByExpenseId(incomeId);
            this.dataService.dispatchAction(fromModel.DATA_ACTION.DELETEINCOME, "IncomeListComponent-openModelDialog-deleteIncome", {income: inc});
            this.dataService.savePlan();
            this.UpdateIncome.emit();         
          }
        });
        break;
      } 
    }
  }

  ngOnDestroy(): void{
    if(this._storeDataSubscription && this._storeDataSubscription !== null){
      this._storeDataSubscription.unsubscribe();
    }        
  }
}
